/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Complete
 *
 * 1 = Pending
 */
export enum VehicleAccidentPaymentStatusEnum {
  Complete = 0,
  Pending = 1,
}
